module.exports = __webpack_public_path__ + "img/Cedric Soares.2d865e92.png";